import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import { useMemo } from 'react'
import { useStore } from 'store'

export const usePeriodoContrato = (value: { dia: string }) => {
    dayjs.extend(utc)
    dayjs.extend(isSameOrAfter)

    const funcionario = useStore(state => state.employee)

    return useMemo(() => {
        const dia = dayjs.utc(value.dia, 'YYYY-MM-DD')

        const isAdmitido = dia.isSameOrAfter(
            dayjs.utc(funcionario?.dtAdmissao),
            'day',
        )

        const isRecindido = funcionario?.dtRescisao
            ? dia.isAfter(dayjs.utc(funcionario.dtRescisao), 'day')
            : undefined

        return !isAdmitido || !!isRecindido
    }, [funcionario])
}
